(function(){
  "use strict";

  angular.module("irricrops")
    .directive('prodBox', [function () {
      return {
        restrict: 'E',
        replace: true,
        templateUrl: 'components/vinedo/productividad/prodbox.tmpl.html',
        scope:{
          pbCuartel: '=',
          pbName:'@',
          pbTitle:'@',
          pbDetail:'=',
          pbPosition:'=',
          pbMedida:'@',
          pbRecalcular:'=',
          pbShowDetails:"=",
          pbDebounce:"=",
        },
        controller: ['$scope',
        function ($scope) {
          $scope.debounceTime = 1000;

        }]
      };
    }]);

})();
